enum RecordingAction {
  Start = 'Start',
  Stop = 'Stop',
  Pause = 'Pause',
  Resume = 'Resume',
}

export default RecordingAction;
